import Radium from "radium";
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import { useParams, useLocation } from 'react-router-dom';
import userImage from "../../Image/user.png";
import Content from '../AllPageContent/AllPageContent';
import CurrentAffair from '../CurrentAffair/CurrentAffair';
import { fetchCUETArticleDetail } from '../DynamicCourse/api';
import Loader from '../Loader/Loader';
import CivilTopSection from '../ReusableComponent/CIVIL/CivilTopSection/CivilTopSection';
import "../ReusableComponent/CIVIL/CivilTopSection/CivilTopSection.css";
import ButtonPage from '../ButtonPage/ButtonPage';
// import cuetinnerimagechatgpt from "../../Image/cuetinnerimage28kb.png";
import cuetinnerimagechatgpt from "../../Image/cuetinnerimagechatgpt.png";


import cuetBg from "../../Image/cuetbannerbackground.jpg";

function DynamicCUETArticle() {
    const { title } = useParams();
    const location = useLocation();
    
    // Attempt to get sn from state, then fallback to sessionStorage
    const [sn, setSn] = useState(() => {
        const stateSn = location.state?.sn;
        if (stateSn) {
            // Save to sessionStorage for refresh fallback
            sessionStorage.setItem(`cuet_article_sn_${title}`, stateSn);
            return stateSn;
        }
        // Fallback to sessionStorage if state is lost (e.g. refresh)
        return sessionStorage.getItem(`cuet_article_sn_${title}`);
    });

    const [newData, setNewData] = useState(null);
    const componentName = "Cuet";

    useEffect(() => {
        // If sn is not in state but might be in sessionStorage from a direct hit
        // (This part is already handled by the useState initializer, but we double check if sn changed)
        const currentSn = location.state?.sn || sessionStorage.getItem(`cuet_article_sn_${title}`);
        if (currentSn && currentSn !== sn) {
            setSn(currentSn);
        }
    }, [location.state, title]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchCUETArticleDetail(sn);
                setNewData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (sn) {
            fetchData();
        }
    }, [sn]);

    if (!newData) {
        return <div style={{ backgroundColor: "white", zIndex: "180", width: "100%", height: "100vh", position: "fixed", top: "0" }}><Loader /></div>
    }

    const data = {
        academyName: newData.Title,
        userImage: userImage,
        userName: 'INSIGHT IAS',
        Image: cuetinnerimagechatgpt, // CUET articles don't have separate images yet
    };

    const paragraphs = newData.Description;

    return (
        <>
            <SeoHelmets 
                title={`${newData.Title} - Insight IAS`} 
                description={newData.Title}
                image={cuetinnerimagechatgpt}
                url={window.location.href}
            />

            <section
                className="dynamic-blog"
                style={{
                    backgroundImage: `url(${cuetBg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                }}
            >
                <CivilTopSection
                    academyName1={data.academyName}
                    userImage={data.userImage}
                    userName={data.userName}
                    Image={data.Image}
                />
            </section>


            <div className='Civil-section'>
                <div className='civil-row'>
                    <div className='col-lg-8 col-md-12 col-sm-12 me-2'>
                        <div className='card p-4'>
                            <Content paragraphs={paragraphs} />
                            <ButtonPage Pagename="EnquiryOnly" noteurl="" />
                        </div>
                    </div>
                    <div className='col-lg-4 col-md-12 col-sm-12'>
                        <div className='card p-2'>
                            <CurrentAffair componentName={componentName} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Radium(DynamicCUETArticle);
